import React, { useEffect, useRef, useState } from 'react';
import styles from './ResultsCollapse.module.scss';
import { Result } from "../../types/SearchData";
import { MinusIcon, PlusIcon } from '../../../../Interfaces/Icons';
import Collapse from 'react-bootstrap/Collapse'
import { Button, Card } from 'react-bootstrap';
import { clearTag } from '../../helpers/Utils';
interface CollapsibleResultProps {
    result: Result;
    forceOpen?: boolean;
    labels: { [key: string]: string };
}
const CollapsibleResult: React.FC<CollapsibleResultProps> = ({ result, forceOpen, labels }) => {
    const [isOpen, setIsOpen] = useState(!!forceOpen);
        const [isExpandable, setIsExpandable] = useState(false);
        const textRef = useRef<HTMLDivElement>(null);
        const getValidSource = (source, name) => {
            if (typeof source !== "string") return [];
            if (source == "") return null;
            try {
                const parsed = JSON.parse(source);
                return parsed;
            } catch (e) {
                return [{
                    "Name": name,
                    "Target": null,
                    "Type": 2,
                    "Udi": null,
                    "Content": null,
                    "Url": source
                }];
            }
        }
        const sources = getValidSource(result?.source, result?.name);

        useEffect(() => {
            if (!result.description) {
                setIsExpandable(false);
                return;
            }

            const plainText = result.description.replace(/<[^>]*>/g, '');
            const minLength = 300;

            setIsExpandable(plainText.trim().length > minLength);
        }, []);

        return (
            <Card>
                <Card.Body>
                    <div className={styles["card-header"]}>
                        <Card.Title>{result.title}</Card.Title>
                        <Button
                            variant="link"
                            className="p-0 border-0"
                            onClick={() => setIsOpen(!isOpen)}
                            aria-controls={`collapse-text-${result.title}`}
                            aria-expanded={isOpen}
                            title={result.title}
                            disabled={!isExpandable}
                            style={{ opacity: isExpandable ? 1 : 0.3 }}
                        >
                        {isOpen ? <MinusIcon /> : <PlusIcon />}
                        </Button>
                    </div>
                    <div className={styles["card-container"]}>
                        <div className={styles["description-container"]}>
                            {result?.description?.length > 0 &&
                            <div ref={textRef} className={`${styles["description"]} ${!isOpen ? styles["text-clamp-3"] : ""}`}>
                                <div dangerouslySetInnerHTML={{ __html: result?.description }} />
                            </div>}
                            {isExpandable && !isOpen && (
                                <div className={styles["read-more"]} onClick={() => setIsOpen(!isOpen)}>
                                    {labels["ReadMoreLabel"]}
                                </div>
                            )}
                            <Collapse in={isOpen}>
                                <div>
                                </div>
                            </Collapse>
                        </div>
                        {sources && sources.length > 0 &&
                            <div className={styles["link"]}><span>{labels["SourceLabel"]}</span>
                                <ul>
                                    {sources.map((link, index) => (
                                        <li key={index}>
                                            <a href={link.Url} target={link.Target || '_self'}>
                                                <i className="bi bi-link"></i> {link.Name}
                                            </a>
                                        </li>

                                    ))}
                                </ul>
                            </div>
                        }
                        {result?.categories && result?.categories?.length > 0 && <div className={styles["categories"]}>
                            <span>{labels["CategoriesLabel"]}</span>
                            <ul>
                                {result?.categories?.map((category, index) => {
                                    if (index == 0) return;
                                    return (
                                        <li key={index}>
                                            {category}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                        }
                        {result?.keywords && result?.keywords?.length > 0 && <div className={styles["keywords"]}>
                            <span>{labels["KeywordsLabel"]}</span>
                            <ul>
                                {result?.keywords?.map((tag, index) => {
                                    return (
                                        <li key={index}>
                                            {clearTag(tag)}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                        }
                    </div>
                </Card.Body>
            </Card>
        );
    };

export default CollapsibleResult;